import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  AccessPermissionService,
  DELETE_RECORD_LABEL,
  DISTANCE_KM_LABEL,
  StorageTypeEnum,
  dblclickTooltipDef,
  defaultColumn,
  grid_widths_map,
} from '@piqet-angular/shared';
import { Helper, ProjectsFacade } from '@piqet-angular/data';
import { cloneDeep } from 'lodash';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class ProjectScenarioRetailDataGridService {
  event: any;
  StorageTypeEnum = StorageTypeEnum;

  deleteRetail = new Subject<[any]>();
  deleteRetailData$ = this.deleteRetail.asObservable();

  editRetailSuccess = new Subject<any>();
  editRetailSuccessData$ = this.editRetailSuccess.asObservable();

  inlineEditing = new Subject<any>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  isCheckEditEol = new Subject<any>();
  isCheckEditEol$ = this.isCheckEditEol.asObservable();

  editProjectRetailSub = new Subject<[any, any]>();
  editProjectRetailSubData$ = this.editProjectRetailSub.asObservable();

  editProjectRetailManualDistanceSub = new Subject<any>();
  editProjectRetailManualDistanceSubData$ = this.editProjectRetailManualDistanceSub.asObservable();

  checkDeleteRowRetail = new Subject<[any, any, boolean]>();
  checkDeleteRowRetailData$ = this.checkDeleteRowRetail.asObservable();
  allTransportLocationRecords: any;

  saveProjectManualDistanceRetail = new Subject<[any, any]>();
  saveProjectManualDistanceRetailData$ = this.saveProjectManualDistanceRetail.asObservable();

  clearInputFieldProjectRetailManualDistance = new Subject<any>();
  clearInputFieldProjectRetailManualDistanceData$ =
    this.clearInputFieldProjectRetailManualDistance.asObservable();

  constructor(
    private projectFacade: ProjectsFacade,
    private swalService: SwalService,
    private toaster: ToastrService,
    private accessService: AccessPermissionService
  ) {}
  projectScenarioRetailPayload: any;

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }

  projectScenarioRetailData(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'StorageProcessname',
      headerName: 'Storage process',
      field: 'storageProcessname',
      // minWidth: grid_widths_map.lg_column_sm,
      cellStyle: { 'text-decoration': 'underline' },
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectFacade.openNewAddProjectRetail(
            params.data.scenarioId,
            params.data.id,
            'Review retail',
            this.StorageTypeEnum.Retail,
            'retail-list'
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'StorageDays',
      headerName: 'Storage days',
      field: 'storageDays',
      // cellClass: 'my-permission-cursor-pointer',
      suppressColumnsToolPanel: true,
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: this.accessPermission(),
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'StorageDays') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellRenderer: (params: any) => {
        return (
          '<span class="editable-icon project-inline-setWidth" >' +
          params.value +
          '<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>'
        );
      },
      cellEditorParams: {
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const valueChanged = params.data[params.colDef.field] !== params.newValue;
        const oldValue = params.data[params.colDef.field];
        const newVal = params.newValue == 0 ? oldValue : params.newValue;
        if (params.newValue == 0) return;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        const field = params.colDef.field;
        const nodeId = params.data.id;
        const inlineObject = {
          entityId: 'id',
          entityIdValue: params.data['id'],
          entityColumnName: params.colDef.field,
          filter: 'agTextColumnFilter',
          entityColumnValue: params.data[params.colDef.field],
        };
        if (!this.isEmpty(newVal) && valueChanged) {
          this.inlineEditing.next(inlineObject);
          return valueChanged;
        } else {
          this.toaster.error('Storage days is required');
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PercentageProductLoss',
      headerName: 'Product loss (%)',
      field: 'percentageProductLoss',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProductLossName',
      headerName: 'Destination of product loss',
      field: 'productLossName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'EndofLifeIdentifierName',
      headerName: 'Destination of package waste',
      field: 'endofLifeIdentifierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Transport',
      headerName: 'Transport to retail',
      field: 'transport',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Destination',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showDelete: true,
          deleteData: (data: any, pathName: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any, pathName: any) => {
            this.projectFacade.openNewAddProjectRetail(
              data.scenarioId,
              data.id,
              'Review retail',
              this.StorageTypeEnum.Retail,
              pathName
            );
          },
        },
        lockVisible: false,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.projectScenarioRetailData()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectScenarioRetailPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'StorageProcessname',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getTransportModalForManualLocationDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Location',
      field: 'originName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      hide: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      // cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Distance') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        isCheckTransportDistance: true,
        from: 'project-pages-inline',
      },
      cellStyle: params => {
        const isCellEditable = params.rowIndex == 0 ? false : true;
        return {
          'pointer-events': isCellEditable ? '' : 'none',
        };
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const oldValue = params.data[params.colDef.field];
        const getDisType = oldValue.substring(oldValue.indexOf(' ') + 1);
        const newVal = params.newValue + ' ' + getDisType;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectFacade.packRetailTransportScenarioManualLocationActions(params.data, 'edit');
          this.editProjectRetailSub.next([params.data, false]);
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        deleteInlineGrid: (data: any) => {
          this.alertConfirmationForManualLocation(data);
        },
        editDataInline: (data: any, pathName: any) => {
          this.projectFacade.packRetailTransportScenarioManualLocationActions(data, 'edit');
          this.editProjectRetailSub.next([data, true]);
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistanceRetail.next([data, 'manualLocation']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectRetailManualDistance.next(data);
        },
      },
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
    });
    return colDef;
  }
  getTransportModalForManualDestinationDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'PersanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
      hide: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        deleteInlineGrid: (data: any) => {
          this.alertConfirmationForDistance(data);
        },
        editDataInline: (data: any, pathName: any) => {
          this.projectFacade.packRetailTransportScenarioActionsFordistance(data, 'edit');
          this.editProjectRetailManualDistanceSub.next(data);
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistanceRetail.next([data, 'manualDistance']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectRetailManualDistance.next(data);
        },
      },
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      resizable: false,
    });
    return colDef;
  }

  getendOfLifeDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: '',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'LandFill',
      headerName: 'Landfill %	',
      field: 'landfill',
      maxWidth: 110,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'LandFill') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Recycling',
      headerName: 'Recycling %	',
      field: 'recycling',
      maxWidth: 135,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Recycling') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'HomeComposting',
      headerName: 'Home composting %	',
      field: 'homeComposting',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'HomeComposting') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CommercialComposting',
      headerName: 'Commercial composting %',
      field: 'commercialComposting',
      maxWidth: 120,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'CommercialComposting') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Incineration',
      headerName: 'Incineration %	',
      field: 'incineration',
      maxWidth: 120,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Incineration') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'WasteEnergyRecovery',
      headerName: 'Energy recovery %	',
      field: 'wasteEnergyRecovery',
      maxWidth: 110,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'WasteEnergyRecovery') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OpenDump',
      headerName: 'Open dump %	',
      field: 'openDump',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'OpenDump') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'AnerobicDigestion',
      headerName: 'Anaerobic digestion %	',
      field: 'anerobicDigestion',
      maxWidth: 109,
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'AnerobicDigestion') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Litter',
      headerName: 'Litter %	',
      field: 'litter',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Litter') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'StormWater',
      headerName: 'Storm water %	',
      field: 'stormWater',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'StormWater') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Sewer',
      headerName: 'Sewer %	',
      field: 'sewer',
      cellClass: 'my-permission-cursor-pointer',
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Sewer') {
          return {
            component: NumericCellEditor,
          };
        }
        return;
      },
      valueSetter: (params: any) => {
        const newVal = params.newValue;
        const valueChanged = params.data[params.colDef.field] !== newVal;
        const oldValue = params.data[params.colDef.field];
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.isCheckEditEol.next(null);
          this.projectFacade.packRetailProcess(params.data, 'edit');
          return valueChanged;
        } else {
          return oldValue;
        }
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: true,
      sortable: false,
      headerClass: 'custom-header-class',
    });

    return colDef;
  }

  getCustomTransportItemsList(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'CityName',
      headerName: 'Origin-destination',
      field: 'cityName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    return colDef;
  }

  alertConfirmationForManualLocation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacade.getTransportScenarioListForRetail$
          .pipe(take(1))
          .subscribe((records: any) => {
            this.allTransportLocationRecords = records;
          });
        this.projectFacade.packRetailTransportScenarioManualLocationActions(data, 'delete');
        this.checkDeleteRowRetail.next([this.allTransportLocationRecords, data, true]);
      }
    });
  }

  alertConfirmationForDistance(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacade.packRetailTransportScenarioActionsFordistance(data, 'delete');
        this.checkDeleteRowRetail.next([undefined, data, false]);
      }
    });
  }
  isEmpty(val: any) {
    val = val.toString();
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteRetail.next([data]);
      } else {
      }
    });
  }

  getRetailList() {
    this.editRetailSuccess.next(() => {});
  }
}
